import { render } from "./ChatInvitation.vue?vue&type=template&id=58b3084f&scoped=true"
import script from "./ChatInvitation.vue?vue&type=script&lang=js"
export * from "./ChatInvitation.vue?vue&type=script&lang=js"

import "./ChatInvitation.vue?vue&type=style&index=0&id=58b3084f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b3084f"]])

export default __exports__